export const PartnerAccountStatusInternalNFR = 'InternalNFR';
export const PartnerAccountStatusPreviousPartner = 'PreviousPartner';
export const PlatformProductIdentifier = 'platform';
export const AsioMemberNameField = 'memberName';

export const VendorAccount = {
    dialogName: 'create_vendor_account_dialog',
    title: 'vendorAccount',
    refName: 'RefName',
    name: 'Name',
};

export const ProductCatalog = {
    SwitchButtons: {
        Products: 1,
        MarketPlaceProducts: 2,
        Packages: 3,
        Entitlements: 4,
        EntitlementManagement: 5,
        EntitlementManagementLog: 6
    }
};
export const ProductSLI3_0 = 'sli 3.0';

export const ProductAutomate = 'automate';

export const ProductManage = 'manage';

/**
 * instanceStatus `identifier` in `product_instances_instance_status` (see Core DB).
 * Override with `terminationPlannedInstanceStatusId` in client config if needed.
 */
export const InstanceStatusTerminationPlanned = 'terminationPlanned';

/**
 * instanceStatus `name` column in DB — no space, PascalCase (e.g. Superset: `TerminationPlanned`).
 * Use this in PATCH; sending a different `name` causes `instanceStatus/name` NotFound.
 */
export const InstanceStatusTerminationPlannedName = 'TerminationPlanned';

/** Human‑readable label for UI (ComboBox, copy); not sent to API as `name`. */
export const InstanceStatusTerminationPlannedLabel = 'Termination Planned';

/**
 * Product instance `metadata` field for **Request for deletion** (status → Termination Planned).
 * Serialized API / metadata key for the request-for-deletion reason.
 */
export const ProductInstanceMetadataAsioRequestForDeletionReason = 'asioRequestForDeletionReason';

/** Set when request-for-deletion starts from Terminated; unlock is not permitted afterward. */
export const ProductInstanceMetadataAsioRequestForDeletionFromTerminated = 'asioRequestForDeletionFromTerminated';

/** Latest unlock / reactivation note (metadata). */
export const ProductInstanceMetadataUnlockPlatformInstanceReason = 'unlockPlatformInstanceReason';

/** Dialog id for unlock platform instance (CW Platform). */
export const UNLOCK_PLATFORM_INSTANCE_DIALOG_KEY = 'unlock_platform_instance_dialog';

/** Dialog id for DialogFactory, `showDialog`, and `hideDialog` (request-for-deletion). */
export const REQUEST_FOR_DELETION_DIALOG_KEY = 'request_for_deletion_dialog';

export const ASIO_UNLOCK_PLATFORM_INSTANCE_REASON_FIELD_KEY = 'asio_unlock_platform_instance_dialog_reason';
const PRODUCT_INSTANCE_REASON_TEXT_MAX_LENGTH = 500;

/** Maximum length allowed for Request for Deletion reason (UI + `applyRequestForDeletion` validation). */
export const REQUEST_FOR_DELETION_REASON_MAX_LENGTH = PRODUCT_INSTANCE_REASON_TEXT_MAX_LENGTH;

/** Maximum length allowed for unlock platform instance reason (UI + `applyReactivatePlatformInstance` validation). */
export const UNLOCK_PLATFORM_INSTANCE_REASON_MAX_LENGTH = PRODUCT_INSTANCE_REASON_TEXT_MAX_LENGTH;

/** Dialog id for package upgrade stepper dialog. */
export const PACKAGE_UPGRADE_DIALOG_KEY = 'package_upgrade_dialog';
export const AUTOFILL_PRODUCTS = ['BrightGauge'];

export const ProductBrightGaugeIdentifier = 'BrightGauge';

export const ProductInstanceMetadataAdditionalDatasourceContractQuantity = 'additionalDatasourceContractQuantity';

export const ProductInstanceMetadataSupportFreeDatasourceQuantity = 'supportFreeDatasourceQuantity';

export const ProductInstanceMetadataBrightGaugeAdditionalDataSourceNotes = 'brightGaugeAdditionalDataSourceNotes';

export const ProductInstanceMetadataBrightGaugeSupportFreeDataSourceNotes = 'brightGaugeSupportFreeDataSourceNotes';

export const PRODUCT_INSTANCE_METADATA_UPDATE_DIALOG_KEY = 'brightgauge_datasource_update_dialog';

export const PRODUCT_INSTANCE_METADATA_NOTES_MAX_LENGTH = PRODUCT_INSTANCE_REASON_TEXT_MAX_LENGTH;

export const PRODUCT_INSTANCE_METADATA_SALESFORCE_OPPORTUNITY_ID_MAX_LENGTH = 100;

export const BRIGHTGAUGE_METADATA_EDIT_CONFIG = {
    dialogKey: PRODUCT_INSTANCE_METADATA_UPDATE_DIALOG_KEY,
    fields: [
        {
            metadataKey: ProductInstanceMetadataAdditionalDatasourceContractQuantity,
            editRole: 'Provisioning',
            label: 'Additional Datasource Contract Quantity',
            notesMetadataKey: ProductInstanceMetadataBrightGaugeAdditionalDataSourceNotes,
            requiresOpportunityId: true,
            requiresSwoContractConfirmation: true,
        },
        {
            metadataKey: ProductInstanceMetadataSupportFreeDatasourceQuantity,
            editRole: 'Advanced User Support',
            label: 'Support Free Datasource Quantity',
            notesMetadataKey: ProductInstanceMetadataBrightGaugeSupportFreeDataSourceNotes,
            requiresOpportunityId: false,
            requiresSwoContractConfirmation: false,
        },
    ],
};

export const UPGRADE_STEPS = {
    SELECT_PACKAGE: 0,
    PREVIEW_DELTA: 1,
    SIGNUP_DATA: 2,
    CONFIRM: 3,
};

/** Delay (ms) after upgrade to allow entitlement service to propagate changes before reload. */
export const UPGRADE_PROPAGATION_DELAY_MS = 2000;

export const ACTIONS_FOR_BULK_MAPPING = {
    MAP: 'MAP',
    UNMAP: 'UNMAP'
};

/** Package `metadata` key for Pricing and Packaging category. */
export const PackageMetadataPricingAndPackagingCategory = 'pricingAndPackagingCategory';

/** Package `metadata` key for whether the package appears in provisioning filters. */
export const PackageMetadataShowPackage = 'showPackage';

export const PRICING_AND_PACKAGING_CATEGORY = [
    { id: 'SwO', name: 'SwO' },
    { id: 'Add Ons', name: 'Add Ons' },
];

/** Provisioning filter value for packages that are neither SwO nor Add Ons. */
export const PricingAndPackagingCategoryNonSwO = 'Non-SwO';

export const PRICING_AND_PACKAGING_CATEGORY_PROVISION = [
    ...PRICING_AND_PACKAGING_CATEGORY,
    { id: PricingAndPackagingCategoryNonSwO, name: PricingAndPackagingCategoryNonSwO },
];

/** Screen-data key for the admin email selected in the Retry Provision dialog typeahead. */
export const RETRY_PROVISION_EMAIL_FIELD = 'retryProvisionDialogEmail';

/** Screen-data key for the Admin role ID used to build the admin-users typeahead endpoint. */
export const RETRY_DIALOG_ROLE_ADMIN_ID = 'retryDialogRoleAdminId';

/** Screen-data key for the admin email selected in the Package Upgrade signup step. */
export const UPGRADE_PROVISION_EMAIL_FIELD = 'upgradeProvisionDialogEmail';

/** Screen-data key for the Admin role ID used by the Package Upgrade signup step typeahead. */
export const UPGRADE_DIALOG_ROLE_ADMIN_ID = 'upgradeDialogRoleAdminId';

/** Screen key for the Product Catalog entitlements tab message panel. */
export const ENTITLEMENTS_TAB_SCREEN_KEY = 'entitlements_tab';

export const PackageRelationType = {
    Eligibility: 'Eligibility',
    Restriction: 'Restriction',
};
